import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

import { AccountTemplate, AccountTemplateSaveResponse } from '../../../types/AccountTemplate';

export const postAccountTemplate = async (formData: AccountTemplateSaveResponse) => {
  const response = await CustomAxios.post(`account_templates`, formData);
  return response.data;
};

type useCreateAccountTemplateProps = {
  onSuccessCallback: (data: AccountTemplate) => void;
};

export function useCreateAccountTemplate({ onSuccessCallback }: useCreateAccountTemplateProps) {
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [mutationKeys.createAccountTemplate],
    mutationFn: (formData: AccountTemplateSaveResponse) => postAccountTemplate(formData),
    onSuccess: (data: AccountTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allAccountTemplates, 'new'],
      });
      onSuccessCallback(data);
      navigate(`/${ROUTE_PATHS.ACCOUNT_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as AccountTemplate;
        queryClient.setQueryData([queryKeys.allAccountTemplates, 'new'], template);
      }
    },
  });
}
